import { useCallback, useContext, useMemo } from 'react';

import { LocalFiltersContext } from '@modules/_shared/components/filters/LocalFiltersContext';
import { parseWhereParam } from '@modules/_shared/utils/listUrlParams';
import { useScopedSearchParams } from '@modules/_shared/utils/navigation';

export const useFiltersSearchParams = (
  queryParamsScope?: string,
): [any, (where: any) => void] => {
  const localContext = useContext(LocalFiltersContext);
  const [searchParams, setSearchParams] =
    useScopedSearchParams(queryParamsScope);

  const setSearchParamsWithWhere = useCallback(
    (where: any) => {
      if (localContext != null) {
        // Local mode - update context, don't touch URL
        localContext.setWhere(where);
      } else {
        // URL mode - existing behavior
        searchParams.set('where', JSON.stringify(where));
        searchParams.delete('offset');
        setSearchParams(searchParams);
      }
    },
    [searchParams, setSearchParams, localContext],
  );

  const value = useMemo(() => {
    if (localContext != null) {
      return localContext.where;
    }

    return parseWhereParam(searchParams.get('where'));
  }, [searchParams, localContext]);

  return [value, setSearchParamsWithWhere];
};
